import styled, { css, keyframes } from 'styled-components';

const loading = keyframes`
  to {
    background-position: 0%;
  }
`;

const Container = styled.div`
  background-color: #fff;
  width: 100%;
  height: 100%;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 10px;
  box-shadow: 0 0 50px #3334;
  padding: 20px;
`;

const Info = styled.p`
  font-size: 1.1rem;
  color: #666;
  font-weight: 600;
  margin-bottom: 25px;
`;

const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  font-size: 15px;
  color: ${props => (props.secondary ? '#424242' : '#fff')};
  border: none;
  background-color: ${props => (props.secondary ? 'transparent' : '#424242')};
  padding: 14px 0;
  font-weight: 600;
  border-radius: 8px;
  width: ${props => (props.loading ? '100%' : 'calc(50% - 5px)')};
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  margin: 5px 0;

  ${props =>
    props.loading &&
    css`
      background-color: #424242;
      background-image: linear-gradient(to right, #009688 50%, #424242 50%);
      background-repeat: no-repeat;
      background-size: 200%;
      background-position: 100%;

      animation: ${loading} 2s ease-in-out forwards;
    `}

  &:first-child {
    margin-right: 10px;
  }
`;

export { Container, Info, Flex, Button };
